import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import UniversalSidebar from './UniversalSidebar';
import UniversalFooter from './UniversalFooter';
import AppBackground from './AppBackground';

export const DRAWER_WIDTH = 240;

const MainContainer = ({ instashellSetup, children }) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleDrawerToggle = () => {
        setMobileOpen(prev => !prev);
    };

    return (
        <>
        <AppBackground />
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', position: 'relative', zIndex: 1 }}>
            {isMobile && (
                <AppBar position="fixed" elevation={0} className="mobile-appbar">
                    <Toolbar sx={{ minHeight: '56px !important' }}>
                        <IconButton
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 1.5, color: 'inherit' }}
                            className="sidebar-font"
                        >
                            <MenuIcon />
                        </IconButton>
                        <span
                            className="sidebar-font"
                            style={{
                                fontFamily: instashellSetup?.sidebarHeader?.titleFont,
                                fontSize: '28px',
                                lineHeight: 1,
                            }}
                        >
                            {instashellSetup?.sidebarHeader?.titleLabel}
                        </span>
                    </Toolbar>
                </AppBar>
            )}

            <div style={{ display: 'flex', flex: 1 }}>
                <UniversalSidebar
                    instashellSetup={instashellSetup}
                    mobileOpen={mobileOpen}
                    onClose={handleDrawerToggle}
                    isMobile={isMobile}
                />
                <main style={{
                    flex: 1,
                    padding: isMobile ? '72px 16px 24px' : '32px 32px 24px',
                    minHeight: '100vh',
                    boxSizing: 'border-box',
                }}>
                    {children}
                </main>
            </div>

            <UniversalFooter
                instashellSetup={instashellSetup}
                isMobile={isMobile}
            />
        </div>
        </>
    );
};

export default MainContainer;
